<div class="pair">
    <warema-svg-icon filePath="assets/images/icons/icon_approved.svg" height="12" width="12" />
    <span>{{ 'APPROVED' | translate }}</span>
</div>
<div class="pair">
    <warema-svg-icon filePath="assets/images/icons/icon_cancelled.svg" height="12" width="12" />
    <span>{{ 'CANCELLED' | translate }}</span>
</div>
<div class="pair">
    <warema-svg-icon filePath="assets/images/icons/icon_open.svg" height="12" width="12" />
    <span>{{ 'OPEN' | translate }}</span>
</div>
<div class="pair">
    <warema-svg-icon filePath="assets/images/icons/icon_closed.svg" height="12" width="12" />
    <span>{{ 'CLOSED' | translate }}</span>
</div>
